import { action } from 'typesafe-actions';
import { Theme, ConfigurableTheme } from '../../styles/types';
import { ThemeActionTypes } from './types';

export const setTheme = (theme: Theme) =>
  action(ThemeActionTypes.SET_THEME, theme);

export const overrideTheme = (customTheme: ConfigurableTheme) =>
  action(ThemeActionTypes.OVERRIDE_THEME, customTheme);
